export default __webpack_public_path__ + "static/cover-5-256e26da2013bedd42590b5eb4d28001.jpg";